<!--数据字典-->
<template>
  <div class="app_container" :class="{ 'list-drag': dragaable }">
    <!--操作栏-->
    <div class="filter_container">
      <butn
        btntype="primary"
        title="新增"
        @click.native="handleAdd"
        v-permission="'dept:save'"
        iconName="el-icon-plus"
      ></butn>
      <!--工具栏-->
      <!-- <el-checkbox :disabled="dragDisabled" v-model="dragaable" class="drag-box"
        >拖拽排序</el-checkbox
      > -->
      <div class="search_right">
        <Search @search="searchHandle" />
      </div>
    </div>
    <Tables @selection-change="selectionChange" :data="paramList" />
    <!-- 编辑新增 -->
    <Curd />
  </div>
</template>
<script>
import Search from "./search";
import butn from "@/components/button/index";
import Bus from "./Bus.js";
import Tables from "./table.js";
import Curd from "./curd";
import {
  schoolList,
  deptDelete,
  findMostTopDept,
  updateDeptOrderByDrag,
} from "@/api/dept";
import "@/components/list/table.css";
import Sortable from "sortablejs";
export default {
  name: "school",
  components: { butn, Search, Tables, Curd },
  data() {
    return {
      paramList: [],
      selections: [], // 列表选中列
      dialogFormVisible: false,
      dataname: {},
      dragaable: false,
    };
  },
  watch: {
    dragaable(val) {
      this.rowDrop(val);
    },
  },
  computed: {
    dragDisabled() {
      // 列表数据不足两条或者有搜索条件时禁用拖拽排序
      if (this.paramList.length < 2 || Object.keys(this.dataname).length > 1) {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.dragaable = false;
        return true;
      }
      return false;
    },
    roleIds() {
      return this.selections.map((item) => item.roleId);
    },
  },
  methods: {
    rowDrop(flag) {
      if (!flag) {
        // 关闭拖拽功能时销毁Sortable对象
        this.sort && this.sort.destroy();
      } else {
        const _this = this;
        const tbody = document.querySelector(".el-table__body-wrapper tbody");
        this.sort = Sortable.create(tbody, {
          animation: 180,
          delay: 0,
          sort: true,
          draggable: ".el-table__row",
          // 开始拖拽的时候
          onEnd({ oldIndex, newIndex }) {
            if (oldIndex === newIndex) return;
            const oldRow = _this.paramList[oldIndex];
            const newRow = _this.paramList[newIndex];
            let offset = newIndex - oldIndex;
            let params = {
              upOrDown: Number(offset) > 0 ? 1 : -1,
              dragUuid: oldRow.id,
              otherUuid: newRow.id,
            };
            updateDeptOrderByDrag(params).then((res) => {
              if (!res || res.code != 0) return;
              _this.$message({
                message: "排序成功",
                type: "success",
              });
              const currR = _this.paramList.splice(oldIndex, 1)[0];
              _this.paramList.splice(newIndex, 0, currR);
            });
          },
        });
      }
    },
    // 获取列表数据
    getDeptList(params) {
      schoolList(params)
        .then((res) => {
          if (res && res.code == 0) {
            this.paramList = res.data;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    handleAdd() {
      Bus.$emit("ReceiveMessage", "");
    },
    selectionChange: function (selections) {
      this.selections = selections;
    },
    //删除
    deleteHandle(item) {
      this.$confirm(`确认要删除该学院数据吗?`, "系统提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.loading = true;
        deptDelete({ uuids: [item.id] })
          .then((res) => {
            if (res && res.code == 0) {
              this.$message.success(res.msg);
              // 更新列表
              this.getDeptList(this.dataname);
            }
          })
          .finally(() => {
            this.loading = false;
          });
      });
    },
    //搜索
    searchHandle(data) {
      this.dataname = { ...data, parentId: this.dataname.parentId };
      this.getDeptList(this.dataname);
    },
    // 初始化
    initTable() {
      findMostTopDept().then((res) => {
        if (res && res.code == 0) {
          this.dataname.parentId = res.data.uuid;
          this.getDeptList(this.dataname);
        }
      });
    },
  },
  created() {
    var _this = this;
    this.initTable();
    Bus.$on("deleteDept", function (item) {
      _this.deleteHandle(item);
    });
    Bus.$on("reload", function () {
      _this.getDeptList({ parentId: _this.dataname.parentId });
    });
  },
  beforeDestroy() {
    Bus.$off("deleteDept");
    Bus.$off("reload");
  },
};
</script>

<style lang="scss" scoped>
/deep/ .drag-box {
  margin-left: 16px;
}
</style>
